<div>

    Nested component here

    <div class="content"> {{= it.content }} </div>

</div>